<script setup>
import {computed} from "vue";
import StatCard from "@/components/global-themed/StatCard.vue";
import BaseCard from "@/components/global-themed/BaseCard.vue";
import {usePyCrawlFormatters} from "@/composables/admin/usePyCrawlAnalytics";

const props = defineProps({
    jobs: {type: Object, required: true},
    pages: {type: Object, required: true},
    performance: {type: Object, required: true},
});

const {formatCount, formatRate, formatDuration} = usePyCrawlFormatters();

const blockedRate = computed(() => {
    const total = props.jobs.blocked_today + props.jobs.completed_today;
    if (!total) {
        return null;
    }
    return props.jobs.blocked_today / total;
});

const completedRate = computed(() => {
    const total = props.jobs.completed_today + props.jobs.blocked_today;
    if (!total) {
        return null;
    }
    return props.jobs.completed_today / total;
});
</script>

<template>
  <BaseCard>
    <h2 class="tw-text-xl tw-font-semibold tw-text-font-primary tw-mb-4">
      Today
    </h2>
    <div class="tw-grid tw-grid-cols-4 tw-gap-3 tw-mb-3">
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(jobs.completed_today) }}
        </template>
        <template #title>
          Jobs Completed ({{ formatRate(completedRate) }})
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(jobs.failed_today) }}
        </template>
        <template #title>
          Jobs Failed
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(jobs.blocked_today) }}
        </template>
        <template #title>
          <div class="tw-flex tw-flex-col tw-items-center tw-gap-0">
            <span>Jobs Blocked ({{ formatRate(blockedRate) }})</span>
          </div>
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatRate(jobs.success_rate_today) }}
        </template>
        <template #title>
          Success Rate
        </template>
      </StatCard>
    </div>
    <div class="tw-grid tw-grid-cols-4 tw-gap-3">
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(pages.crawled_today) }}
        </template>
        <template #title>
          Pages Crawled
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(pages.avg_per_job_today) }}
        </template>
        <template #title>
          Avg Pages / Job
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatDuration(performance.avg_duration_seconds_today) }}
        </template>
        <template #title>
          Avg Duration
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatDuration(performance.p95_duration_seconds_today) }}
        </template>
        <template #title>
          P95 Duration
        </template>
      </StatCard>
    </div>
  </BaseCard>
</template>
